import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Card, CardBody, Container, Spinner } from "reactstrap";
import { extractAuthResultFromExchangeResponse } from "helpers/authSession";
import { exchangeSsoCode, resolveSsoErrorMessage } from "model/SsoModel";
import { useUserContext } from "libs/context/UserContext";

const SsoCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { completeLoginSession } = useUserContext() || {};
  const exchangeStartedRef = useRef(false);

  document.title = "Signing in | Ancile Services";

  const redirectToLoginWithError = (message) => {
    navigate("/login", {
      replace: true,
      state: { ssoError: resolveSsoErrorMessage(message) },
    });
  };

  useEffect(() => {
    if (exchangeStartedRef.current) return;
    exchangeStartedRef.current = true;

    const errorCode = searchParams.get("error");
    if (errorCode) {
      redirectToLoginWithError(errorCode);
      return;
    }

    const code = searchParams.get("code");
    if (!code) {
      redirectToLoginWithError("Missing sign-in code. Please try again.");
      return;
    }

    (async () => {
      try {
        const response = await exchangeSsoCode(code);
        const session = extractAuthResultFromExchangeResponse(response);

        if (!session) {
          redirectToLoginWithError(
            response?.message ??
              response?.Message ??
              "Sign-in failed. Please try again."
          );
          return;
        }

        await completeLoginSession?.(session);
      } catch (err) {
        redirectToLoginWithError(
          err?.message ?? err?.Message ?? "Sign-in failed. Please try again."
        );
      }
    })();
  }, []);

  return (
    <div className="bg-cream d-flex align-items-center justify-content-center">
      <Container>
        <div className="d-flex justify-content-center">
          <Card className="login-card" style={{ maxWidth: 420, width: "100%" }}>
            <CardBody className="p-4 text-center">
              <h4 className="fw-bold mb-3">Signing you in…</h4>
              <Spinner color="warning" />
            </CardBody>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default SsoCallback;
